import styled from 'styled-components';

const ProfessionalRetailerStyle = styled.div`
    /* position: fixed;
    z-index: 999; 
    top: 50px;
    left: 50%;
    transform: translateX(-50%); */
    /* max-width: 1320px; */
    width: 100%;
    padding: 270px 0 100px;
    position: relative;

    @media only screen and (max-width:1280px) {
        padding: 220px 0 70px;
    }

    @media only screen and (max-width:767px) {
        padding: 142px 0 50px;
    }

    .container {
        position: relative;
        z-index: 99;
    }

    .professional-form { 
    /* position: relative;    */
    height: 100%;
    overflow-y: auto;

    &.showSuccessMessage {
        .success {
            padding: 10px;
            margin: 0; 
            height: 100px;

            p {
                margin: 0;
            }
        }
    }


    button.MuiButtonBase-root {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9;
    background: #fff;
    border-radius: 0;


    svg.MuiSvgIcon-root {
    font-size: 22px;
    color: var(--green);
}
}
form.signupform.main-sign-frm {
  /* position: static;
  transform: translate(0); */
  justify-content: space-between;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.03);
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 30px 60px;
  max-width: 630px;
  width: 100%;
  @media (max-width: 767px){
    max-width: calc(100% - 15px);
    padding: 20px;
  }
  &>p{
        font-size: 24px;
        color: #ffffff;
        font-family: var(--common-font);
        text-align: center;
        margin-bottom: 30px;
        line-height: normal;
        @media (max-width: 767px){
            font-size: 18px;    margin-bottom: 20px;
        }
    }
    .form-control,select#myId {
    line-height: normal;
    border-radius: 30px;
    width: 100%;
    height: 40px;
    border: 1px solid #b2b2b2;
    font-size: 16px;
    max-width: 100%;
    text-align: left;
    color: #999999;
}
textarea.form-control{
    height: 150px;
    overflow-y: auto;
    @media (max-width: 767px){
        height: 100px;
    }
}
button.btn-primary {
    font-size: 20px;
    color: #000000;
    font-weight: bold;
    font-family: var(--common-fontmd);
    text-align: center;
    background: #fff;
    border-radius: 30px;
    width: 100%;
    max-width: 220px;
    margin: 0 auto;
    text-transform: uppercase;
    display: flex;
    font-weight: 600;
    justify-content: center;
    @media (max-width: 767px){
        font-size: 18px;
    }
}
h6 {
    font-size: 22px;
    color: #000;
}
label{
    font-weight: normal;
    font-family: var(--common-fontmd);
}
 .field-class.d-flex {
    font-size: 14px;
    gap: 5px;
    font-family: var(--common-fontmd);
    input[type="checkbox"] {
    width: 18px;  
    @media (max-width: 767px){
        margin-top: 0;
        & > div {
            align-items: center;
            display: flex;
        }
    }
}  
&:not(:last-child()){
        margin-right: 10px;
    }
} 
}
.mb-0.mt-3.field-class {
    margin: 30px 0 0;
}
    }
    .success {
        color:  #fff;
        text-align: center;
        margin-top: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(95, 181, 190);
    }
`;

export default ProfessionalRetailerStyle;